export const ROOT = 'StepPayment/formPayment/price';

export const FETCH_PRICE_REQUEST = `${ROOT}/FETCH_PRICE_REQUEST`;
export const FETCH_PRICE_FAILURE = `${ROOT}/FETCH_PRICE_FAILURE`;
export const FETCH_PRICE_SUCCESS = `${ROOT}/FETCH_PRICE_SUCCESS`;
